import { FC } from 'react';
import { Card, Col, Grid, Image, Row, Typography } from 'antd';
import { ButtonBorder } from 'src/components/Forms/Button';
import IconCustom from 'src/components/Icon/Custom';
import classes from './event.module.less';
interface CardArticleInterface {
  data?: any;
}
const CardEventHome: FC<CardArticleInterface> = props => {
  const {
    xs
  } = Grid.useBreakpoint();
  const lengths = xs ? 35 : 45;
  const eventData: any = props?.data;
  const truncateString = (str: string) => {
    if (str?.length > lengths) {
      return `${str.substring(0, lengths)}...`;
    }
    return str;
  };
  const cardStyle = {
    boxShadow: '0 4px 15px rgba(229, 189, 189, 0.89)',
    transition: 'box-shadow 0.3s ease',
    margin: '10px',
    borderRadius: '8px'
  };
  return <div className={classes.containerCard}>
			<Row>
				{eventData.length === 0 ? <Col sm={24} md={24} lg={24} xl={24} xs={24}>
						<div style={{
          textAlign: 'center',
          padding: '20px'
        }}>
							<Image alt="empty-event" src="/icons/emptyEvent.svg" className={classes.imageContainer} preview={false} loading='lazy' />
						</div>
					</Col> : eventData?.map((item: any) => {
        return <Col sm={12} md={12} lg={12} xl={12} xs={24} key={item.id}>
								<Card style={cardStyle} bordered={false} onMouseEnter={e => {
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(232, 146, 146, 0.99)';
          }} onMouseLeave={e => {
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(233, 176, 176, 0.88)';
          }}>
									<Row>
										<Col sm={{
                span: 24,
                order: 1
              }} md={11} lg={11} xl={11} xs={{
                span: 24,
                order: 1
              }} style={{
                textAlign: xs ? 'center' : 'left'
              }}>
											<Image src={item?.image_files?.[0]?.path || '/hb-logo.png'} height={200} width={200} preview={false} style={{
                  borderRadius: '8px'
                }} alt={item.name} loading='lazy' />
										</Col>
										<Col sm={{
                span: 24,
                order: 2
              }} md={12} lg={12} xl={12} xs={{
                span: 24,
                order: 2
              }} style={{
                marginLeft: xs ? '5px' : '10px'
              }}>
											<Typography className={classes.title}>
												{truncateString(item.title)}
											</Typography>
											<div>
												<Row>
													<Col sm={3} md={3} lg={3} xl={3} xs={3} className="d-flex align-items-center text-align-center">
														<IconCustom iconName="calender_branda" />
													</Col>
													<Col sm={21} md={21} lg={21} xl={21} xs={21}>
														<Row>
															<Col>
																<Typography className="fs-12 fs-md-14 ml-2 fw-600">
																	{item.start_date_text}
																</Typography>
															</Col>
														</Row>
														<Row>
															<Col>
																<Typography className="fs-12 fs-md-14 ml-2" style={{
                            color: '#4A4545'
                          }}>{item.start_hour_text}</Typography>
															</Col>
														</Row>
													</Col>
												</Row>
												<Row>
													<Col sm={3} md={3} lg={3} xl={3} xs={3} className="d-flex align-items-center">
														<IconCustom iconName={item.address.length !== 0 ? 'location_branda' : 'video_branda'} />
													</Col>
													<Col sm={21} md={21} lg={21} xl={21} xs={21}>
														<Typography className="fs-12 fs-md-14 ml-2 fw-600">
															{item.address.length !== 0 ? 'Event Offline' : 'Event Online'}
														</Typography>
													</Col>
												</Row>
												<Row style={{
                    marginTop: '5px'
                  }}>
													<Col sm={3} md={3} lg={3} xl={3} xs={3} className="d-flex align-items-center">
														<IconCustom iconName="speaker_branda" />
													</Col>
													<Col sm={21} md={21} lg={21} xl={21} xs={21}>
														<Typography className="fs-12 fs-md-14 ml-2 fw-600">{item.guest_speaker}</Typography>
													</Col>
												</Row>
												<div style={{
                    marginTop: '10px'
                  }}>
													<a href={`/event/${item.slug}`} id="home-lihat-detail-event">
														<ButtonBorder style={{
                        cursor: 'pointer'
                      }} text={'Lihat Detail'} className={classes.btn} />
													</a>
												</div>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>;
      })}
			</Row>
		</div>;
};
export default CardEventHome;